import React from "react";
import styled from "styled-components";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";

const AppDownloadBanner = ({
  text,
  appStoreUrl,
  googlePlayUrl,
  bgImagePath = "rewards/pg-app-image-parralax.jpg",
}) => {
  const bgImage = useResponsiveImageUrl(bgImagePath);

  return (
    <BannerSection bgImage={bgImage}>
      <container-div>
        <BannerContent>
          <BannerText>{text}</BannerText>
          <ButtonGroup>
            <StoreLink href={appStoreUrl} target="_blank" rel="noopener noreferrer">
              <ResponsiveImage
                src="promotions/download-and-win-2026/app-store.png"
                alt="Download on the App Store"
              />
            </StoreLink>
            <StoreLink href={googlePlayUrl} target="_blank" rel="noopener noreferrer">
              <ResponsiveImage
                src="promotions/download-and-win-2026/google-play.png"
                alt="Get it on Google Play"
              />
            </StoreLink>
          </ButtonGroup>
        </BannerContent>
      </container-div>
    </BannerSection>
  );
};

const BannerSection = styled.div`
  width: 100%;
  background: url(${(props) => props.bgImage}) center center / cover no-repeat;
  padding: 20px 0;
  position: relative;

  container-div {
    position: relative;
    z-index: 2;
  }
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (min-width: 991px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }
`;

const BannerText = styled.h2`
  font-weight: 900;
  margin: 0 0 1rem;
  color: var(--white);
  text-align: center;
  font-size: 1.2rem;

  @media (min-width: 991px) {
    margin: 0;
    white-space: nowrap;
    gap: 1rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;

  a {
    padding: 0;
    border-radius: 8px;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent !important;
    border: none !important;
    overflow: visible;

    &:hover {
      opacity: 0.8;
      background: transparent !important;
    }

    img,
    svg,
    picture img {
      height: 50px;
      width: auto;
      display: block;
      max-width: none;
    }

    picture {
      display: flex;
      height: 50px;
    }
  }
`;

const StoreLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 8px;
  transition: opacity 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  img {
    height: 50px;
    width: auto;
  }
`;

export default AppDownloadBanner;
